import {Component, OnInit, Input, ViewChild, ElementRef, OnDestroy, Output, EventEmitter} from "@angular/core";
import {Observable} from "rxjs";
import * as Communication from "../communication/index";
import {Router, ActivatedRoute} from "@angular/router";
import {Config} from "../../environments/environment";
import {HttpErrorResponse} from "@angular/common/http";
import {NavigationService} from "../shared/common/NavigationEventService";
import {NavigationEvent} from "../shared/common/NavigationEvent";
import { Subscription } from 'rxjs';
import {ToolbarService} from "../shared/common/ToolbarEventService";
import {NotificationService} from "../shared/common/NotificationService";
import {legacyRedirectUrl} from "../shared/common/legacy-redirect";
import {DisclosureService, DisclosureRequirement} from '../shared/services/disclosure.service';
import {ToolbarEventPageEnum, ToolbarEvent} from "../shared/common/ToolbarEvent";
import {Authorization} from "../shared/authorization/authorization.component";
import {TranslateService} from '@ngx-translate/core';

declare var $:any;
declare var swal: any;
declare var hwcrypto:any;

/**
 * This class represents the lazy loaded AccountComponent.
 */
@Component({
    selector: 'sd-multisigning',
    templateUrl: 'multisigning.component.html',
    styleUrls: ['multisigning.component.css'],
    providers: [Communication.JobsService, Communication.RecipientRequestService, Communication.MultiRecipientRequestService, DisclosureService],
    standalone: false
})
export class MultiSigningComponent implements OnInit, OnDestroy {
  subscriptions:Subscription[] = [];
  requestCode:string="";
  multiRequestResults:any[] = [];

  // --- Disclosure consent for a bundle ---------------------------------------------------
  // Shown if ANY job in the bundle requires it; one on-screen acceptance, fanned out
  // server-side to one row per job so each job's Signing Log stands alone.
  disclosureGateOpen: boolean = false;
  disclosure: DisclosureRequirement = null;
  disclosureModalVisible: boolean = false;
  disclosureModalOpened: boolean = false;
  disclosureLoading: boolean = false;
  disclosureSubmitting: boolean = false;

  // PDF viewer preview modal state (view action, PADES rows) + viewer controls.
  viewModalVisible:boolean = false;
  viewPdfSrc:string = null;
  viewingName:string = "";
  viewRotation:number = 0;
  viewZoom:number = 1.0;
  viewPage:number = 1;
  viewTotalPages:number = 1;

  hwcryptoModel:any = {
    hashtype: 'SHA-256',
    backend: 'chrome',
    language: 'tr',
    filter: 'SIGN',
    certificate: ''
  };

  constructor(
    private activatedRoute:ActivatedRoute,
    private router:Router,
    private authorization: Authorization,
    private toolbarService: ToolbarService,
    private notificationService: NotificationService,
    private translate: TranslateService,
    private navigationService:NavigationService,
    private recipientRequestApi: Communication.RecipientRequestService,
    private multiRecipientRequestApi: Communication.MultiRecipientRequestService,
    private disclosureService: DisclosureService)
  {


  }


  ngOnInit() {

      this.subscriptions.push(this.navigationService.eventOccured$.subscribe(
        (event:NavigationEvent) => this.onNavigationEvent(event)
      ));

      this.toolbarService.action(new ToolbarEvent(ToolbarEventPageEnum.JOB_MULTISIGN_REQUEST, "ME_OTHERS", null, "WAITING", "", "", "", "", ""));

      this.subscriptions.push(this.activatedRoute.params.subscribe(
        (param) => {
          this.requestCode = param['code'];
          console.log("requestCode: "+ this.requestCode);

          if(param['code'] == null){
            //TODO:ERROR
            this.notificationService.showAccessDenied();
            return;
          }

          console.log("params: ", param, this.requestCode);

          this.getRecipientRequests();
          this.resolveDisclosureGate();

        })
      );

  }

getRecipientRequests() {

  this.subscriptions.push(this.multiRecipientRequestApi.multirecipientrequestsCodeGet(this.requestCode).subscribe(
    (response:any) => {
      //console.log("response: " , response);

      //No result for requestCode
      if(response.length == 0) {
        console.log("response has no element...");
        this.notificationService.showURLInfoIncorrent(function(isConfirmed:boolean) {
          if (isConfirmed){}
        });
      }

      for(let i=0; i<response.length; i++) {
        let item:any = {
          jobId: response[i].jobId,
          jobStatus: response[i].jobStatus,
          jobName: response[i].recipientRequest.recipient.jobNameForRecipient,
          created: response[i].document.created,
          page: response[i].document.page,
          size: response[i].document.size,
          // Per-row signature (P / C_*) drives the view/download icon; startTime is the
          // "İstek Zamanı" (request time, epoch-millis, may be null); the per-row recipient_request
          // code fetches the preview; isRegistered gates the info icon.
          signature: response[i].signature,
          startTime: response[i].startTime,
          code: response[i].recipientRequest?.code,
          isRegistered: response[i].recipientRequest?.recipient?.isRegistered
        };

        this.multiRequestResults.push(item);
      }
      console.log("multiRequestResults: ", this.multiRequestResults);

    }, //Bind to view
    (err: any) => {
      // Log errors if any
      console.log(err);

      // 276: the bundle holds an in-progress job sent under an older API version, which is
      // signed on the legacy app. Without a legacy app, the 276 message is shown below.
      if (err instanceof HttpErrorResponse && err.error?.code == 276) {
        const legacyUrl = legacyRedirectUrl();
        if (legacyUrl) {
          console.log(`API version incompatible, redirecting to ${legacyUrl}`);
          // localStorage is kept: the legacy app is on its own origin (see signing.component).
          window.location.href = legacyUrl;
          return;
        }
      }

      this.notificationService.displayError(err);
    }
  ));

}

  private onNavigationEvent(event:NavigationEvent) {
    switch (event.acton) {
      case "APPROVE_SIGN":
      {
        this.ApproveSign();
        break;
      }
    }
  }

  ApproveSign(){
    console.log("run ApproveSign...");

    // createMultiTokenSignature is one of the four server-gated methods, so without
    // this check a bundle signer would meet a flat server rejection with nothing on screen
    // explaining it. Decline is untouched: it is a separate navbar action and is never gated.
    if (this.disclosureGateOpen) {
      this.notificationService.disclosureNotAccepted();
      return;
    }

    this.openEidSign();
  }

  // ------------------------------------------------------------------------------------
  // Disclosure consent gate for the bundle
  // ------------------------------------------------------------------------------------

  /** Ask whether any job in this bundle requires consent, and whether it is already given. */
  private resolveDisclosureGate(): void {
    if (!this.requestCode) return;

    this.subscriptions.push(this.disclosureService.getBundleRequirement(this.requestCode).subscribe(
      (requirement) => {
        if (!requirement || !requirement.required || requirement.accepted || !requirement.versionId) {
          return;
        }

        // The text arrives with the requirement, so there is no second fetch and no window in
        // which the rendered words and the recorded version could come from different reads.
        this.disclosure = requirement;
        this.disclosureGateOpen = true;
        this.disclosureLoading = false;
      },
      // Fail open: the server-side check is the real gate, so a lookup failure must not brick
      // the bundle. The signer reaches a clear rejection rather than an unusable page.
      (err) => console.error('Disclosure requirement could not be resolved; continuing', err)
    ));
  }

  openDisclosureModal(): void {
    this.disclosureModalVisible = true;
    this.disclosureModalOpened = true;
  }

  closeDisclosureModal(): void {
    this.disclosureModalVisible = false;
  }

  acceptDisclosure(): void {
    if (!this.disclosure || this.disclosureSubmitting) return;

    this.disclosureSubmitting = true;

    this.subscriptions.push(this.disclosureService.acceptBundle(this.requestCode, {
      disclosureVersionId: this.disclosure.versionId,
      modalOpened: this.disclosureModalOpened
    }).subscribe(
      () => {
        this.disclosureSubmitting = false;
        this.disclosureGateOpen = false;
        this.disclosureModalVisible = false;
      },
      (err) => {
        this.disclosureSubmitting = false;
        this.notificationService.displayError(err);
      }
    ));
  }

  public openEidSign() {
    let self = this;

    if (!(<any>window).hwcrypto.use(this.hwcryptoModel.backend)) {
      console.log("Selecting backend failed.");
    }

    (<any>window).hwcrypto.getCertificate({lang: this.hwcryptoModel.language, filter: this.hwcryptoModel.filter}).then(function (certificate: any) {
      console.log("certificate received...");
      self.hwcryptoModel.certificate = certificate;

      self.subscriptions.push(self.recipientRequestApi.recipientRequestsCodeMultitokenhashPut(self.requestCode, certificate.hex).subscribe(
        (response:any) => {
          console.log("token hash received...", response);

          //sign the hash
          self.signWithHwcrypto(response.resources[0].source);

        }, //Bind to view
        (err:any) => {
          // Log errors if any
          self.notificationService.displayError(err);
          console.log(err)
        }
      ));

    }, function (error: any) {
      console.log("Certificate error: ", error.message);
      self.notificationService.OpenEIdSigningError(error.message);
    });

  }

  base64toHEX(base64:string) {
    let HEX:any = '';
    let raw: any = atob(base64);

    for (let i = 0; i < raw.length; i++) {
      let _hex: any = raw.charCodeAt(i).toString(16);
      HEX += (_hex.length == 2 ? _hex : '0' + _hex);
    }

    console.log("HEX: ", HEX);
    console.log("HEX SIZE: ", HEX.length);

    return HEX;
  }


  signWithHwcrypto(hash:string) {
    let self = this;

    // sign the hash
    (<any>window).hwcrypto.sign(
      this.hwcryptoModel.certificate, {type: this.hwcryptoModel.hashtype, hex: this.base64toHEX(hash)},
      {lang: this.hwcryptoModel.language, info: "hashcount=" + this.multiRequestResults.length})
      .then(function (signature: any) {
        console.log("signature received..", signature);

        self.subscriptions.push(self.recipientRequestApi.recipientRequestsCodeMultitokensignaturePost(self.requestCode, signature.hex, "error").subscribe(
          (response:any) => {
            console.log("Signing successful...",response);
            self.toolbarService.action(new ToolbarEvent(ToolbarEventPageEnum.JOB_MULTISIGN_REQUEST, "ME_OTHERS", null, "SIGNED", "All Docs", "", "", "", ""));

            let unsignedJobs:string[]=[];
            for(let i=0;i<response.length;i++) {
              if(response[i].code !== '200') {
                const result = self.multiRequestResults.filter(x => x.jobId == response[i].id);
                unsignedJobs.push(result[0].jobName);
              }
            }

            self.notificationService.showAllJobsSigned(unsignedJobs, function(isConfirmed:boolean) {
              if (isConfirmed){
                self.router.navigate(['/docs']);
              }
            })

          }, //Bind to view
          (err:any) => {
            // Log errors if any
            self.notificationService.displayError(err);
            console.log(err)
          }
        ));

      }, function (error: any) {
        // Handle the error. `error.message` is one of the described error mnemonics
        console.log("Signing failed: " + error.message);
        self.notificationService.OpenEIdSigningError(error.message);

      }).catch((error:any) => {
      console.log('Error', error);
    });

  }

  // ===== Per-row view / download / info actions =====

  /** PADES ('P') → render the preview in the pdf-viewer modal. */
  isPAdES(signature:string):boolean {
    return signature === 'P';
  }

  /** CADES → download the binary preview. Prefix check covers every C_* variant
   *  (C_ENV, C_DET, C_ENV_T, C_DET_LTA, …), not just the two current values. */
  isCAdES(signature:string):boolean {
    return !!signature && signature.indexOf('C_') === 0;
  }

  /** Info icon is shown ONLY to a logged-in, registered signer — never to guests. */
  isLoggedIn():boolean {
    return !!this.authorization.getAccessToken();
  }
  canShowInfo(item:any):boolean {
    return this.isLoggedIn() && !!item?.isRegistered && item.isRegistered !== 'false';
  }

  /** View a PADES preview PDF in the compact pdf-viewer modal. */
  viewDocument(item:any) {
    if(!item?.code) {
      return;
    }
    this.subscriptions.push(this.recipientRequestApi.recipientRequestsCodeDownloadGet(item.code, "", 'response').subscribe(
      (data:any) => {
        const contentType = data.headers?.get('Content-Type') || 'application/pdf';
        const blob = new Blob([data.body], { type: contentType });
        this.revokeViewUrl();
        this.viewPdfSrc = window.URL.createObjectURL(blob);
        this.viewingName = item.jobName;
        this.viewRotation = 0;
        this.viewZoom = 1.0;
        this.viewPage = 1;
        this.viewTotalPages = 1;
        this.viewModalVisible = true;
        setTimeout(() => { $('#multiSignViewModal').modal('show'); }, 100);
      },
      (err:any) => {
        console.log(err);
        this.notificationService.documentNotFound();
      }
    ));
  }

  /** Download a CADES (binary) preview file. Never fed to the pdf-viewer. */
  downloadDocument(item:any) {
    if(!item?.code) {
      return;
    }
    this.notificationService.documentDownloadStarted(item.jobName);
    this.subscriptions.push(this.recipientRequestApi.recipientRequestsCodeDownloadGet(item.code, "", 'response').subscribe(
      (data:any) => {
        const contentType = data.headers?.get('Content-Type') || 'application/octet-stream';
        const blob = new Blob([data.body], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', item.jobName);
        link.click();
        window.URL.revokeObjectURL(url);
      },
      (err:any) => {
        console.log(err);
        this.notificationService.documentNotFound();
      }
    ));
  }

  /** Info → the logged-in job-details page (opened in a NEW TAB) with its info modal
   *  auto-opened (#info fragment). */
  openInfo(item:any) {
    if(!item?.jobId) {
      return;
    }
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/doc', item.jobId], { fragment: 'info' })
    );
    window.open(url, '_blank');
  }

  // --- pdf-viewer controls (view modal) ---
  onPdfLoad(pdf:any) {
    this.viewTotalPages = (pdf && pdf.numPages) ? pdf.numPages : 1;
  }
  rotateView() {
    this.viewRotation = (this.viewRotation + 90) % 360;
  }
  zoomIn() {
    this.viewZoom = Math.min(this.viewZoom + 0.25, 3);
  }
  zoomOut() {
    this.viewZoom = Math.max(this.viewZoom - 0.25, 0.25);
  }
  nextPage() {
    if(this.viewPage < this.viewTotalPages) {
      this.viewPage++;
    }
  }
  prevPage() {
    if(this.viewPage > 1) {
      this.viewPage--;
    }
  }

  closeViewModal() {
    this.viewModalVisible = false;
    $('#multiSignViewModal').modal('hide');
    this.revokeViewUrl();
  }

  private revokeViewUrl() {
    if(this.viewPdfSrc) {
      try { window.URL.revokeObjectURL(this.viewPdfSrc); } catch(e) {}
      this.viewPdfSrc = null;
    }
  }

  ngOnDestroy() {
    this.revokeViewUrl();
    this.subscriptions.forEach(
      (s:Subscription) => s.unsubscribe()
    );
  }
}
